/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo – Träffa nytt folk, chatta och ha kul!",
      "Felaktigt telefonnummer",
      "Get the app",
      "Fortsätt med Apple",
      "Fortsätt med Facebook",
      "Fortsätt med Google",
      "Logga in",
      "Registrera dig",
      "För att fortsätta, skriv in de tecken du ser i inmatningsfältet.",
      "Fortsätt",
      "Skriv in tecken",
      "Säkerhetskontroll",
      "Uppdatera",
      "Skapa ett nytt lösenord som du enkelt kan komma ihåg:",
      "Uppdatera",
      "Bekräfta lösenord",
      "Lösenordet måste bestå av minst {{num}} [[characters:num]]",
      "Lösenord",
      "Skapa ett nytt lösenord",
      "Badoo – The Blog",
      "Lediga jobb",
      "Chatt",
      "Städer",
      "Hantera cookies",
      "Copyright © 2006 – dagens datum. Bumble. Alla rättigheter förbehålls.",
      "Apple och logotypen för Apple är varumärken som tillhör Apple Inc.{{__EOL__}}Google Play är ett varumärke som tillhör Google LLC.",
      "Ladda ner",
      "Facebook",
      "Följ oss",
      "Hjälpcenter",
      "Instagram",
      "Språk",
      "LinkedIn",
      "Översikt",
      "Badoo är del av Bumble Inc.",
      "Sekretesspolicy",
      "Säkerhetscenter",
      "Webbplatskarta",
      "Uttalande om Modern Slavery Act",
      "Villkor och regler",
      "Twitter",
      "Ange din e-postadress eller ditt mobilnummer så skickar vi instruktioner om ur du skapar ett nytt lösenord.",
      "Skaffa nytt lösenord",
      "Lägg till din e-postadress eller mobilnummer",
      "Glömt lösenord",
      "Modellerna används endast i illustrativt syfte",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Du behöver inte vänta på en matchning.{{__EOL__}}{{__EOL__}}Hoppa direkt till djupa samtal och den bästa biten – alltså biten där man lär känna varandra på riktigt.",
      "Redo att chatta nu?",
      "Genom att registrera dig godkänner du våra <a class=\"link\" href=\"{{terms_url}}\">Villkor och regler</a>. <br/>Läs mer om hur vi använder din information i vår <a class=\"link\" href=\"{{privacy_url}}\">Sekretesspolicy</a>",
      "Vi hjälper dig att visa mer av dig själv och <br />dejta personer som får dig att må bra.",
      "Trygg dejting börjar här.",
      "Eller",
      "Har du redan ett konto?",
      "Registrera dig med e-post eller telefonnummer",
      "Få ut det du söker av dejtandet.{{__EOL__}}Utan kompromisser.",
      "Bara här för att chatta? Ingen fara.{{__EOL__}}Redo att slå dig ned? Kör hårt.{{__EOL__}}{{__EOL__}}Här kan du dessutom ändra dig när som helst.",
      "För att dejta",
      "För ett förhållande",
      "För att chatta",
      "Träffa personer som söker samma sak.",
      "{{name}}, {{age}}",
      "Din säkerhet är vår högsta prioritet.",
      "Vårt säkerhetscenter är ett kunskapsnav där du hittar all support du behöver för att dejta tryggt.",
      "Besök vårt säkerhetscenter",
      "Säkerhet först –<br/>alltid.",
      "Jag visste från första början att det skulle fungera...",
      "I början var jag inte ute efter något seriöst ...",
      "Mitt bästa råd till alla på Badoo är att vara sig själva...",
      "Berättelser från Badoo",
      "Kolla in fler berättelser",
      "{{num}}__CUT__Omdöme",
      "Apple App Store",
      "Lita på oss. Vi har fört samman miljoner (och miljoner och miljoner) människor sedan 2006.",
      "Över {{num}} mn__CUT__nedladdningar",
      "{{num}} mn+",
      "Google Play Butik",
      "Vi kan det här.",
      "Logga in med e-post eller telefonnummer",
      "Ange ditt lösenord",
      "Glömt lösenord?",
      "Bli medlem",
      "Har du inget konto?",
      "Logga in",
      "Bli medlem"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "tecken",
                  "teckens"
            ],
            "singular": [
                  "tecken",
                  "teckens"
            ]
      },
      "day": {
            "plural": [
                  "dagar",
                  "dagars"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timmar",
                  "timmars"
            ],
            "singular": [
                  "timme",
                  "timmes"
            ]
      },
      "minute": {
            "plural": [
                  "minuter",
                  "minuters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "månader",
                  "månaders"
            ],
            "singular": [
                  "månad",
                  "månads"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "års"
            ],
            "singular": [
                  "år",
                  "års"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
